const pendencias = [
  {
    entity: 'laudos',
    singular: 'laudo',
    cause: 'incompleto',
    subtitle: 'Alguns valores nos laudos estão faltando.',
    route: 'pendencias-laudos-index',
    disabled: false
  },
  {
    entity: 'visitas',
    singular: 'visita',
    cause: 'incompleta',
    subtitle: 'Algumas visitas estão sem balancetes.',
    route: 'pendencias-visitas-balancetes-index',
    disabled: false
  }
]

export default pendencias
